(()=>{
    const options = {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0.4
    };
    let menuItems;
    let observers = [];
    let currentNavId;
    const setActiveLink = (entry)=>{
        let activeMenuItem = currentNavId === "flyout-menu" && entry.target.id === "welcome" ? document.querySelector("#mobile-logo-link") : document.querySelector(`#${currentNavId} li a[href="#${entry.target.id}"]`);
        if (activeMenuItem) {
            menuItems.forEach((menuItem)=>menuItem.parentElement.classList.remove("active"));
            activeMenuItem.parentElement.classList.add("active");
        }
    };
    const setAddressHash = (id)=>{
        window.history.replaceState({}, "", `#${id}`);
    };
    const getThreshold = (targetId, sectionHeight, viewportHeight)=>{
        let targetVisiblePercent = 0.40;
        if (targetId === "locations") targetVisiblePercent = 0.60;
        /**
     * Calculates the intersection threshold for a section based on viewport height.
     * Uses defensive programming to ensure valid threshold values [0, 1]:
     * - Math.max(0, ...) ensures we never return negative values, which could happen if:
     *   - sectionHeight is 0 (prevents Infinity from division by zero)
     *   - viewportHeight or targetVisiblePercent become negative (future code changes)
     *   - browser reports unexpected layout values during animations/resizing
     * - Math.min(1, ...) caps the threshold at 1 (100%) when the section is smaller
     *   than the target visible percentage of the viewport
     */ return Math.min(1, Math.max(0, viewportHeight * targetVisiblePercent / sectionHeight));
    };
    const resizeObserver = new ResizeObserver((entries)=>{
        observers.forEach((observer)=>observer.disconnect());
        observers = [];
        const width = entries[0].contentRect.width;
        const isMobile = width <= 767;
        const menuQuerySelector = isMobile ? "#flyout-menu a, #mobile-logo-link" : "#topbar-menu a, #desktop-logo-link";
        menuItems = document.querySelectorAll(menuQuerySelector);
        currentNavId = isMobile ? "flyout-menu" : "topbar-menu";
        menuItems.forEach((linkElement)=>{
            const targetId = linkElement.getAttribute("href").split("#")[1];
            const targetElement = document.getElementById(targetId);
            if (!targetElement) return;
            const sectionHeight = targetElement.offsetHeight;
            const viewportHeight = window.innerHeight;
            options.threshold = getThreshold(targetId, sectionHeight, viewportHeight);
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) {
                        setActiveLink(entry);
                        setAddressHash(entry.target.id);
                    }
                });
            }, options);
            observer.observe(targetElement);
            observers.push(observer);
        });
    });
    resizeObserver.observe(document.body);
    const cleanup = ()=>{
        resizeObserver.disconnect();
        observers.forEach((observer)=>observer.disconnect());
        observers = [];
    };
    window.addEventListener("pagehide", cleanup, {
        passive: true
    });
    window.addEventListener("beforeunload", cleanup, {
        passive: true
    });
})();

//# sourceMappingURL=path0.58185f37.js.map
